import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Material, Order, Size } from '../../../order.model';
import { User } from '../../../../auth/user.model';
import { AuthService } from '../../../../auth/auth.service';
import { OrderService } from '../../../order.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { StorageService } from '../../../../storage/storage.service';
import { UIService } from '../../../../shared/ui.service';
import { Subscription } from 'rxjs/index';
import { Reservation } from '../../../../reservation/reservation.model';

export interface DialogData {
  address: string;
  size_wanted: Size;
  id: number;
}

@Component({
  selector: 'app-set-for-switch',
  templateUrl: './set-for-switch.component.html',
  styleUrls: ['./set-for-switch.component.css']
})
export class SetForSwitchComponent implements OnInit {

  user: User;
  binFormGroup: FormGroup;
  deliveryDateFormGroup: FormGroup;
  isLoading = false;

  largeBinIds = [1, 2, 5, 6];
  heavyMaterialIds = [1, 5, 6, 10];

  selectedMaterialReview = 'Aucun';
  selectedBinSizeReview = 'Aucun';
  addressReview = 'Aucun';
  deliveryDateReview;
  deliveryInformationReview = 'Aucun';
  currentLanguage = 'en';

  materials = [];
  binSizes = [];
  binSizesFull = [];
  binSizesHeavy = [];

  now = moment();

  price: number = 0;

  private loadingSubscription: Subscription;

  constructor(
    public dialogRef: MatDialogRef<SetForSwitchComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Order,
    private orderService: OrderService,
    private authentication: AuthService,
    private _formBuilder: FormBuilder,
    private localStorage: StorageService,
    private uiService: UIService,
  ) { }

  minimumDate = this.now.add(1, 'days');

  daysComplete = {
    '2018': [181, 182, 183, 151, 146, 21],
    '2019': [152, 136, 121]
  };

  myFilter = (momentDate: moment.Moment): boolean => {
    const day = momentDate.day();
    if (day === 0 || day === 6) {
      console.log('is sunday or saturday');
      return false;
    }
    const dayOfYear = momentDate.dayOfYear();
    const year = momentDate.year();
    const dayCompleteList =  this.daysComplete[year];

    if (dayCompleteList !== undefined && dayCompleteList.indexOf(dayOfYear) !== -1) {
      console.log('in list');
      return false;
    }
    return true;
  }

  ngOnInit() {

    this.loadingSubscription = this.uiService.loadingStateChanged.subscribe(isLoading => {
      this.isLoading = isLoading;
    });

    this.currentLanguage = this.localStorage.getPreferredLanguage();
    this.user = this.authentication.getUser();

    this.getMaterials();
    this.getBinSizes();

    this.deliveryDateFormGroup = this._formBuilder.group({
      deliveryDate: [{disabled: true}, Validators.required]
    });

    this.binFormGroup = this._formBuilder.group({
      material: ['', Validators.required],
      size_wanted: ['', Validators.required],
      delivery_information: ['']
    });


    let tomorrow  = moment(new Date()).add(1, 'days');
    tomorrow = tomorrow.hour(13).minutes(0).seconds(0).millisecond(0);

    this.deliveryDateFormGroup.setValue({deliveryDate: moment(this.data.delivery_date)});

    this.deliveryDateFormGroup.setValue({deliveryDate: tomorrow});
    this.setBinSizesByMaterialId(this.data.material.id);
    this.price = this.calculatePrice(this.data.size_wanted.id, this.data.material.id);
    this.binFormGroup.setValue({
      size_wanted: this.data.size_wanted.id,
      material: this.data.material.id,
      delivery_information: ''
    });
  }

  getMaterials() {
    this.orderService.getMaterials(this.user.token).subscribe((response: [Material]) => {
      this.materials = response;
      this.uiService.loadingStateChanged.next(false);
    });
  }

  getBinSizes() {
    this.orderService.getBinsizes(this.user.token).subscribe((response: [Size]) => {
      this.createSizesFiltered(response);
      this.uiService.loadingStateChanged.next(false);
    });
  }

  createSizesFiltered(binSizes) {
    for (const binSize of binSizes) {
      let formattedBinSizes = {
        'id': binSize.id,
        'name': binSize.name,
        'disabled': false
      };
      this.binSizesFull.push(formattedBinSizes);

      if (this.largeBinIds.includes(binSize.id)) {
        formattedBinSizes = {
          'id': binSize.id,
          'name': binSize.name + ' ( Trop lourd )',
          'disabled': true
        };
      } else {
        formattedBinSizes = {
          'id': binSize.id,
          'name': binSize.name,
          'disabled': false
        };
      }
      this.binSizesHeavy.push(formattedBinSizes);
    }
  }

  setBinSizesByMaterialId(selectedMaterialId) {
    if (this.heavyMaterialIds.includes(selectedMaterialId)) {
      this.binSizes = this.binSizesHeavy;
    } else {
      this.binSizes = this.binSizesFull;
    }
  }

  onMaterialSelectionChanged(event) {
    const selectedMaterialId = event.value;
    this.setBinSizesByMaterialId(selectedMaterialId);
    this.binFormGroup.patchValue({'size_wanted': null});
    this.price = this.calculatePrice(this.binFormGroup.value.size_wanted, this.binFormGroup.value.material);
    this.binFormGroup.patchValue({'price': this.price});
  }

  onBinSizeSelectionChanged(event) {
    const selectedbinSizeId = event.value;
    this.price = this.calculatePrice(this.binFormGroup.value.size_wanted, this.binFormGroup.value.material);
    this.binFormGroup.patchValue({'price': this.price});
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  authorizeSwitch($event, order) {
    const reservation: Reservation = {
        'id': -1,
        'address': this.data.address,
        'longitude': this.data.longitude,
        'latitude': this.data.latitude,
        'delivery_date': this.deliveryDateFormGroup.value.deliveryDate.toJSON(),
        'size_wanted': this.binFormGroup.value.size_wanted,
        'material': this.binFormGroup.value.material,
        'delivery_information': this.binFormGroup.value.delivery_information
      };
    this.orderService.setOrderForSwitch(this.user.token, order, reservation).subscribe((result: Order) => {
        this.dialogRef.close();
    });
  }

  calculatePrice(sizeWantedId: number, materialId: number) {
    let price = 0;
    const webPriceAdjustment = 0;
    if (materialId === 11 || materialId === 4) {
      if(sizeWantedId === 3){
        price = 485;
      } else if (sizeWantedId === 1){
        price = 555;
      } else if (sizeWantedId === 2){
        price = 625;
      } else if (sizeWantedId === 5){
        price = 685;
      } else if (sizeWantedId === 6){
        price = 895;
      }
    }
    if (materialId === 1 || materialId === 10) {
      price = 625;
    }
    if (materialId === 5 || materialId === 6) {
      price = 525;
    }

    if (sizeWantedId === 5) {
      if (materialId === 1) {
        price = 875;
      }
      if (materialId === 5) {
        price = 725;
      }
      if (materialId === 6) {
        price = 725;
      }
    }
    if (materialId === 11 && sizeWantedId === 9) {
        price = 225;
    }
    if (materialId === 11 && sizeWantedId === 7) {
        price = 345;
    }
    if (materialId === 11 && sizeWantedId === 8) {
        price = 385;
    }
    if (price > webPriceAdjustment){
      price = price - webPriceAdjustment;
    }
    return price;
  }
}
